
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {sancionStore} from "@/store/sancionStore";
import {http} from "@/config/HttpClient";
import {DateTime} from "luxon";
import {MaterialService} from "@/services/MaterialService";
import {Alert} from "@/addons/Alert";
import InputUnsignedDecimal from "../../components/InputUnsignedDecimal.vue";
import InputUppercaseRequired from "../../components/InputUppercaseRequired.vue";
import InputUppercase from "../../components/InputUppercase.vue";
import {materialStore} from "@/store/materialStore";
import {IngresoService} from "@/services/IngresoService";
import {SalidaService} from "@/services/SalidaService";
import {ingresoStore} from "@/store/ingresoStore";
import {salidaStore} from "@/store/salidaStore";
import * as stream from "stream";

@Component({
  name: "salidaNewManual",
  components: {InputUnsignedDecimal, InputUppercaseRequired, InputUppercase},
})
export default class extends Vue {
  sancion = {
    codigo: '',
    meses_plazo: 1,

  }

  @Prop() isNew!: boolean
  private iniciado = 'Iniciado'
  private materialStore = materialStore();
  private sancionStore = sancionStore();
  private ingresoStore = ingresoStore();
  private salidaStore = salidaStore();
  private materialService = MaterialService.getInstance();
  private ingresolService = IngresoService.getInstance();
  private salidaService = SalidaService.getInstance();
  private fecha = DateTime.now().toFormat("yyyy-MM-dd");
  private headers = [
    {text: "Fecha", value: "fecha"},
    {text: "Acción", value: "accion"},
    {text: "Usuario", value: "user.email"}
  ];

  //search = null;
  validBuscar = false;
  valid = false;
  txtBuscar = '';
  cantidad = 1;
  historialVisible = false;

  cantidad_entregada = 1;
  precio_unitario = 1;
  isEdit = false;
  txtNroTramite = '';
  isLoading = false;
  swEditar = true;
  txtSearch = "";
  selected_funcionario = null;
  txtFuncionario = "";
  centro_costos = ''

  salida = {
    id: '',
    codigo: '',
    numero_almacen: '',
    tipo: '',
    tipo_instalacion: this.tipoInstalacion,
    fecha_despacho: DateTime.now().toFormat('yyyy-MM-dd'),
    recibe_material_funcionario_id: '',
    autoriza_material_funcionario_id: '',
  };
  clientes = [];
  materiales = [];
  funcionarios_all = [];
  medidores_all = [];

  cliente_seleccionado = null;
  private numero_almacen = null;
  private tipo_salida = null;
  private txtCodigo = null;
  private lectura = '';
  public medidor= {
    id: '',
    serie: ''
  };

  private opcion: any = "Presupuesto";

  //private sancion = [];

  //private sancion = null;

  $refs!: {
    form: HTMLFormElement,
    codigo: HTMLInputElement,
    txtCuenta: HTMLInputElement,
    montoRec: HTMLInputElement,
  };

  mounted() {
    this.getFuncionarioResponsable();
    this.getFuncionarioResponsableAutoriza();
    this.getNuevoCodigo();
    this.getTipo();
    this.getCentroCostos();
  }

  deleteMaterialesIngreso(){
    const data = {
      ingreso: this.nuevoCodigo
    }
    this.ingresolService.deleteMaterialesIngreso(data);
  }

  get salidaMateriales(): any[] {
    return this.salidaStore.salidasMaterial;
  }

  addMaterialValeSalida(codigo: string) {
    if (this.cantidad > 0 && this.cantidad_entregada > 0 && this.precio_unitario > 0 && (this.cantidad >= this.cantidad_entregada)) {
      const data = {
        codigo: codigo,
        cantidad: this.cantidad,
        cantidad_entregada: this.cantidad_entregada,
        precio_unitario: this.precio_unitario,
        numero: this.nuevoCodigo,
        salida: this.salidaNueva.codigo
      }
      this.salidaService.addMaterialSalida(data);
      this.cantidad = 1;
      this.cantidad_entregada = 1;
      this.precio_unitario = 1;
      this.materialStore.materiales = [];
    } else {
      Alert.error('La cantidad debe ser mayor a 0, la cantidad debe ser mayor o igual a la cantidad entregada')
      return false
    }
  }

  buscarCentroCosto(){
    const data = {
      fun: this.salida.recibe_material_funcionario_id
    };
    this.salidaService.obtenerCentroCosto(data);
  }
  get centroCostoFuncionario(): string {
    return this.salidaStore.centroCostoFuncionario;
  }
  get centroCostos(): any {
    return this.salidaStore.centroCostos;
  }
  getCentroCostos() {
    this.salidaService.getCentroCostos();
  }

  get historiales(): any[] {
    return this.salidaStore.historial;
  }
  get medidores(): any {
    return this.salidaStore.medidores;
  }

  get salidaNueva(): any[] {
    return this.salidaStore.newSalida;
  }

  get presupuesto(): any[] {
    return this.salidaStore.presupuesto;
  }
  get tipoInstalacion() {
    return this.salidaStore.tipoInstalacion;
  }

  get ingresoMaterial(): any[] {
    return this.ingresoStore.ingresoMaterial;
  }

  get nuevoIngreso(): any[] {
    return this.ingresoStore.ingreso;
  }

  get loading(): boolean {
    return this.materialStore.loading;
  }

  get esEdiatr(): boolean {
    return this.ingresoStore.esEditar;
  }

  get nuevoCodigo(): string {
    return this.salidaStore.nuevoCodigo;
  }

  get tipo(): any {
    return this.ingresoStore.tipo;
  }

  getTipo() {
    this.ingresolService.getTipoSalida();
  }

  getNuevoCodigo() {
    this.salidaService.getNuevoCodigo()
  }

  get sancionNueva(): any[] {
    return this.sancionStore.sancionNueva;
  }

  get cliente(): any[] {
    return this.sancionStore.cliente;
  }

  get funcionarioResponsableAutoriza(): any {
    return this.ingresoStore.funcionario_responsable_autoriza;
  }

  getFuncionarioResponsableAutoriza() {
    this.ingresolService.getFuncionarioResponsableAutoriza();
  }

  get funcionarioResponsable(): any {
    return this.ingresoStore.funcionario_responsable;
  }

  getFuncionarioResponsable() {
    this.ingresolService.getFuncionarioResponsable();
  }

  round(value: number) {
    return Math.round(value * 100) / 100;
  }

  getHistoriaL(){
    const data = {
      salida: this.salidaNueva,
      modelo: 'salida',
    };
    this.salidaService.historial(data);
  }

  getMateriales(value: string) {
    this.loading;
    this.materialService.getMateriales(value);
  }
  elejirOpcion() {
    this.txtCodigo = null;
    this.$refs.codigo.focus();
  }

  @Watch('txtSearch')
  search(value: string) {
    if (value != null && value.length > 2) {
      this.$nextTick().then(() => {
        this.getMateriales(value);
      })
    }
  }

  guardar() {
    if (!this.$refs.form.validate()) {
      return;
    }
    Alert.confirm(`Guardar la salida del Presupuesto: <br>
                    ${this.numero_almacen}`
    ).then(res => {
      if (res.isConfirmed) {

        if (this.salidaNueva.length !== 0) {
          const data = {
            salidaId: this.salidaNueva.id, salida: this.salida, tipo: this.opcion, tipoInstalacion: this.tipoInstalacion, centroCostos : this.centroCostoFuncionario
          }
          this.salidaService.updateSalida(data);
        } else {
          const data = {
            salida: this.salida,
            numero: this.nuevoCodigo,
            numero_almacen: this.numero_almacen,
            presupuesto: this.presupuesto,
            tipo: this.opcion,
            tipoInstalacion: this.tipoInstalacion,
            centroCostos : this.centroCostoFuncionario
          }
          this.salidaService.saveSalida(data);
        }
        this.$emit('listar')
      }
    })
    // setTimeout(this.getHistoriaL,3500)

  }

  buscarPresupuesto() {
    const data = {
      numero_almacen: this.numero_almacen,
      tipo: this.opcion,
    }
    this.salidaService.getPresupuesto(data);
    this.salidaStore.medidores = [];
  }

  finalizarIngreso() {
    if (!this.$refs.form.validate()) {
      return;
    }
    Alert.confirm(`Esta seguro de finalizar la salida? <br>
                    Una vez aceptado se procedera a afectar las cantidades de los materiales del presupuesto<br>
                    Revise bien por favor`
    ).then(res => {
      const data = {presupuesto: this.presupuesto, numero_almacen: this.numero_almacen, codigo: this.salidaNueva.codigo}
      if (res.isConfirmed) {
        this.salidaService.finalizarSalida(data);
        this.$emit('listar')
      }
    })

    // if(this.salidaNueva.length !== 0){
       //this.getHistoriaL()
    // }
  }

  saveMedidor() {
    Alert.confirm(`Medidor seleccioando correcto?  <br>
                Serie:  ${this.medidor.serie}`
    ).then(res => {
      const data = {medidor: this.medidor, codigo: this.nuevoCodigo, lectura: this.lectura}
      if (res.isConfirmed) {
        this.salidaService.saveMedidor(data);
        this.$emit('listar')
      }
    })
  }

  updateQuantity(material:object, cantidad_entregada:number){
    const data = {
      material: material,
      ingreso: this.nuevoCodigo,
      cantidad_entregada: cantidad_entregada
    }
    this.ingresolService.updateQuantity(data);
  }
  getMedidores(value:string){
    this.loading
    this.salidaService.getMedidores(value)
  }

  @Watch('txtFuncionario')
  searchFuncionario(value: string) {
    if(value != null && value.length > 5){
      this.$nextTick().then( () => {
        this.getMedidores(value);
      })

      this.medidores_all = this.salidaStore.medidores;

    }
  }

  valesalida = {
    id: '',
    codigo: 0,
    fecha: DateTime.now().toFormat('yyyy-MM-dd'),
    item: '',
    nombre_completo: '',
    area_trabajo: '',
    tipo: 'Vale de Salida',
    adquirido: false,
    destino: '',
    funcionario_id: ''
  };

  seleccionFuncionario(){
    if(this.selected_funcionario !== null){
      this.medidor= {
        id: this.selected_funcionario.id,
        serie: this.selected_funcionario.serie
      }
    }else
      this.limpiar()

  }

  imprimir(id:number){
    if (id === undefined){
      Alert.error('Primero guarde la Salida')
      return false
    }
    this.salidaService.imprimirMedidor(id);

  }

  limpiar() {
    this.funcionario = {
      item: '',
      ci: '',
      nombre_completo: ''
    }
  }

}
